(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mx-featured-product--size-guide"] && !Shopify.designMode) return;
  try {
    $('.fancybox').fancybox();
  } catch(e) { console.error(e); }
})();

})();
